import { Component } from '@angular/core';
import { Toast } from 'ngx-toastr';

// Reference: https://github.com/scttcper/ngx-toastr/blob/master/src/app/pink.toast.ts
@Component({
  selector: 'app-error-toastr',
  templateUrl: './error-toastr.component.html',
  styleUrl: './error-toastr.component.scss'
})

export class ErrorToastrComponent extends Toast {
  closeToast(): void {
    this.remove();
  }
}
